<template>
    <div>
      <div id="screen__pc">
        <div class="sub-title-wrap">
            <div class="sub-title">
                <img src="@/assets/images/dominance_images/logo.png" class="logo__img" />
                <h2>{{ title }}</h2>
                <img class="guide_img" @click="$emit('guideClick')" src="@/assets/images/dominance_images/chart_desc_icon.png" />
            </div>
            <div class="search-container" v-if="type == 'analysis'">
                <input
                type="text"
                :placeholder="$t('pub.searchCoin')"
                class="search-input"
                v-model="localSearchCoin"
                />
                <button class="search-button">
                <img src="@/assets/images/dominance_images/search_icon.png" alt="Search" />
                </button>
            </div>
        </div>
        
      </div>
      <div id="screen__mobile" :class="type == 'analysis' ? 'flex-column' : ''">
        <div class="sub-title">
          <img src="@/assets/images/dominance_images/logo.png" class="logo__img" />
          <h2>{{ title }}</h2>
          <img class="guide_img_mobile" @click="$emit('guideClick')" src="@/assets/images/dominance_images/chart_desc_icon.png" />
        </div>
        <div class="search-container" v-if="type == 'analysis'">
            <input
            type="text"
            :placeholder="$t('pub.searchCoin')"
            class="search-input"
            v-model="localSearchCoin"
            />
            <button class="search-button">
            <img src="@/assets/images/dominance_images/search_icon.png" alt="Search" />
            </button>
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: "TitleSection",
    props: {
      title: String,
      type: String
    },
    data() {
    return {
      localSearchCoin: this.searchCoin || "",
    };
  },
  watch: {
    localSearchCoin(newValue) {
      this.$emit("update:searchCoin", newValue);
    },
  },
  };
  </script>
  